import Vue from 'vue'

const apis = {
  QUERY_SELECT_FORM_LIST: {
    url: '/xdap-app/menu/queryAllFormMenu',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_FORM_FIELD: {
    url: '/xdap-app/reportFormConfig/query/reportFormComponent',
    method: 'get',
    disableSuccessMsg: true
  }
}
const querySourceMenu = (appId, callback) => {
  return new Promise((resolve, reject) => {
    if (appId) {
      const request = {
        ...apis.QUERY_SELECT_FORM_LIST,
        params: {
          appId: appId
        }
      }
      Vue.prototype.$request(request).asyncThen((resp) => {
        if (resp.code === 'ok') {
          callback(resp)
          resolve(resp)
        } else {
          callback(resp)
          resolve(resp)
        }
      })
    } else {
      const error = { code: 'error' }
      callback(error)
      resolve()
    }
  })
}
const queryFormField = (formId, callback) => {
  return new Promise((resolve, reject) => {
    if (formId) {
      const request = {
        ...apis.QUERY_FORM_FIELD,
        params: {
          formId: formId
        }
      }
      Vue.prototype.$request(request).asyncThen((resp) => {
        if (resp.code === 'ok') {
          callback(resp)
          resolve(resp)
        } else {
          callback(resp)
          resolve(resp)
        }
      })
    } else {
      const error = { code: 'error' }
      callback(error)
      resolve()
    }
  })
}

export default {
  editorConfigType: 'DATA_SOURCE_CONFIG',
  componentName: 'FormConfigDataSource',
  configProperty: 'statisticalDataSource',
  extras: {
    querySourceMenu: querySourceMenu,
    queryFormField: queryFormField
  }
}
